import useSWR from 'swr'

import * as T from 'types'
import * as E from 'types/enums'

import { fetch } from '../../fetchers'

export const useServices = () => {
  const response = useSWR<T.IService[]>('/services', fetch)
  const allServices = response?.data

  const services = response?.data?.filter(
    (service: T.IService) =>
      service.forSale
      && service.status === 'Active'
      && Object.prototype.hasOwnProperty.call(service, 'price')
      && service.type?.includes(E.ServiceType.Public),
  )

  const pricingPackageServices = response?.data?.filter((service: T.IService) =>
    (Object.values(E.PackageType) as string[]).includes(service.name),
  )
  return { ...response, services, pricingPackageServices, allServices }
}
